import React from 'react';
import OurVision from './OurVision';

const About = () => {
  return (
    
   <>
    <div className="breadcrumbs overlay">
    <div className="container">
      <div className="bread-inner">
        <div className="row">
          <div className="col-12">
            <h2>About Us</h2>
          </div>
        </div>
      </div>
    </div>
  </div>

  
    <section className="about-area section">
      <div className="container-fluid p-0">
        <div className="row m-0">
          <div className="col-lg-6 col-md-12 p-0">
            <div className="about-image"></div>
          </div>
          <div className="col-lg-6 col-md-12 p-0">
            <div className="about-content">
              <span>About Us</span>
              <h2>Short Story About  Wallabies Warm Care</h2>
              <p>
              Wallabies Warm Care is a well-known name when we talk about
temperature management platforms. We have set the benchmark of the
utmost excellence in quality and affordability. Irrespective of the products
when you are looking for the best clinical and engineering aspects of
patient warming products then our name comes first on the list. This
platform is established to serve different sections of society by providing
quality products. Our highly advanced products offer uniform distribution of
warmth across the entire body of the patient by the highly advanced
micropore system. The concept of a forced air patient warming blanket is
the same as a cocoon, it functions like a warm cocoon that&#39;s why it is
sometimes addressed as a cocoon blanket. Along with blankets, we also
offer patient warming units.
              </p>
              <span>Who are we? </span>
              <p>
              Wallabies Warm Care is the leading producer and supplier of forced air-
warming systems and forced air-warming blankets. We take pride in
serving society with quality products. Our products are designed as per the
requirements of the patients and we always take care of the complete
comfort of the patient while designing a forced air-warming system. The
appreciation that we get from our customers is a prime source of constant
motivation for us. The biggest advantage of our business is that we are
able to serve the patients in some way; which is a great feeling and
provides immense satisfaction.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <OurVision/>
   </>
  );
};

export default About;
